// src/environments/environment.ts
export const environment = {
    production: false,
    apiBaseUrl: 'https://staging-aca-api.wowhp.com/'
};